"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get12HrTimeWithSeconds = exports.get12HrTime = void 0;
var get12HrTime = function (unix) {
    var date = new Date(unix);
    return date.toLocaleString("en-US", {
        hour: "numeric",
        hour12: true,
        minute: "numeric",
    });
};
exports.get12HrTime = get12HrTime;
var get12HrTimeWithSeconds = function (unix) {
    var date = new Date(unix);
    return date.toLocaleString("en-US", {
        hour: "numeric",
        hour12: true,
        minute: "numeric",
        second: "numeric",
    });
};
exports.get12HrTimeWithSeconds = get12HrTimeWithSeconds;
